import {MARKER_LAYERS} from 'Utils/constants';
import * as mapManager from 'Utils/explorer/mapManager';
import scanMarker from 'Utils/scanMarker';

const setScanLocation = feature => () => {
    mapManager.removeMarkers(MARKER_LAYERS.SCAN_LOCATION);
    mapManager.addPointsToMap({
        points: [feature.geometry.coordinates],
        markerLayer: MARKER_LAYERS.SCAN_LOCATION,
        customMarker: scanMarker,
    });
};

export default setScanLocation;
